export const getCdnBaseUrl = (cdnDomain: string) => `https://${cdnDomain}`;
export const getCdnImageBaseUrl = (cdnDomain: string) => `${getCdnBaseUrl(cdnDomain)}/image/upload`;
export const getCdnVideoBaseUrl = (cdnDomain: string) => `${getCdnBaseUrl(cdnDomain)}/video/upload`;

const layer = {
  sizes: ['(min-width: 769px) 60vw', '100vw'],
  srcSetWidths: [700, 900, 1200, 1600],
  ratio: 1.25,
};

const layerZoom = {
  sizes: ['100vw'],
  srcSetWidths: [900, 1200, 1600, 2000],
  ratio: 1.25,
};

const thumbnail = {
  sizes: ['(min-width: 769px) 19vw', '48vw'],
  srcSetWidths: [350, 450, 600, 800],
  ratio: 1,
};

const fabricInfo = {
  sizes: ['(min-width: 769px) 900w', '1600w'],
  srcSetWidths: [900, 1600],
  ratio: 1,
};

const fabricInfoZoom = {
  sizes: ['(min-width: 1024px) 60vw', '100vw'],
  srcSetWidths: [900, 1600, 2000],
  ratio: 1,
};

const sheetWidth = 820;

export const imageDefinition = {
  layer,
  layerZoom,
  thumbnail,
  fabricInfo,
  fabricInfoZoom,
  sheetWidth,
};

export const getImageBaseUrl = (cdnDomain: string) => getCdnImageBaseUrl(cdnDomain);

export const fabricThumbnailDefaultPath = 'products/cm-sample/default/';

export const viewModelImageBasePath = 'suitconfig/{fabricId}/{product}/ai-generated/ai-model';
